import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {AuthConfigService} from '@app/auth-config/services/auth-config.service';
import {CustomPasswordComponent} from '@app/shared/components/custom-password/custom-password.component';
import {EffectsModule} from '@ngrx/effects';
import {ValidationService} from '../shared/services/validation.service';
import {SharedModule} from '../shared/shared.module';
import {SignUpRequestComponent} from './components/sign-up-request/sign-up-request.component';
import {ThankYouComponent} from './components/thank-you/thank-you.component';
import {SignUpPageComponent} from './pages/sign-up-page/sign-up-page.component';
import {SignUpService} from './services/sign-up.service';
import {SignUpEffects} from './state/sign-up.effects';
@NgModule({
  exports: [SignUpPageComponent],
  imports: [
    ReactiveFormsModule,
    SharedModule,
    EffectsModule.forFeature([SignUpEffects]),
    CustomPasswordComponent,
    SignUpPageComponent,
    SignUpRequestComponent,
    ThankYouComponent,
  ],
  providers: [SignUpService, ValidationService, AuthConfigService],
})
export class SignUpModule {}
